import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useGetMessageDetails } from "../../ServerSideStates";
import { useEffect } from "react";
import { handleSetMessageDetaisList } from "../../ClientSideStates";
import { CheckOutlined, ClockCircleOutlined, UserOutlined } from "@ant-design/icons";
import { Image, Avatar } from "antd";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import dayjs from "dayjs";
import ChatMessageListSkeleton from "apps/Common/Skelton/MessageDetails/ChatMessageList";
import { FallbackObj } from "helpers/ImageFallBack";

const MessageList = () => {
  const { messageDetilsFilter, messageDetailsListData } = useSelector(
    (state: RootState) => state.message
  );
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const messageDetails = useGetMessageDetails(messageDetilsFilter);
  const dispatch = useDispatch();

  useEffect(() => {
    if (messageDetails.data && !messageDetails.isLoading) {
      const allData = messageDetails.data?.data;
      const formattedData = {
        ...allData,
        advertMessage: allData.advertMessage.data.map((advert: any) => ({
          ...advert,
          isSaved: true,
        })),
      };

      dispatch(handleSetMessageDetaisList({ data: formattedData || {} }));
    }
  }, [messageDetails.data, messageDetails.isLoading, dispatch]);

  const handePostiionMessage = (item: any, type: string = "postion") => {
    let ownerStatus = item.ownerId === userInfoes.id;

    if (ownerStatus) {
      if (item.isOwnerMessage) {
        return 1;
      }
      return type === "position" ? "justify-start" : 0;
    } else {
      if (item.isContactMessage) {
        return 1;
      }
      return 0;
    }
  };

  const handeUserProfileImaage = (item: any) => {
    let ownerStatus = item.ownerId === userInfoes.id;
    let imageUrl = '';

    if (ownerStatus) {
      if (item.isOwnerMessage) {
        imageUrl = item.ownerPhotoUrl;
      } else {
        imageUrl = item.contactPhotoUrl;
      }
    } else {
      if (item.isContactMessage) {
        imageUrl = item.contactPhotoUrl;
      } else {
        imageUrl = item.ownerPhotoUrl;
      }
    }

    // Backslash'leri forward slash'e çevir
    return imageUrl ? imageUrl.replace(/\\/g, '/') : '';
  };

  // Profil fotoğrafı var mı kontrol eden fonksiyon
  const hasProfileImage = (item: any) => {
    const imageUrl = handeUserProfileImaage(item);
    return imageUrl && imageUrl.trim() !== '';
  };

  // Kullanıcı adının ilk harfini alan fonksiyon
  const getUserInitial = (item: any) => {
    let ownerStatus = item.ownerId === userInfoes.id;

    console.log("ownerStatusownerStatus", item); 
    
    if (ownerStatus) {
      if (item.isOwnerMessage) {
        return item.ownerName?.charAt(0)?.toUpperCase() || 'U';
      }
      return item.contactName?.charAt(0)?.toUpperCase() || 'C';
    } else {
      if (item.isContactMessage) {
        return item.contactName?.charAt(0)?.toUpperCase() || 'C';
      }
      return item.advert.user.name?.charAt(0)?.toUpperCase() || 'U';
    }
  };

  console.log(messageDetails);

  return (
    <ChatMessageListSkeleton loading={messageDetails.isFetching}>
      <div className="flex-1 !overflow-auto space-y-4">
        {messageDetailsListData?.advertMessage?.map((msg: any, index: number) => {
          return (
            <div
              key={index}
              id="position"
              className={`!flex items-start space-x-3 ${
                handePostiionMessage(msg) ? "justify-end" : "justify-start"
              }`}
            >
              {handePostiionMessage(msg, "background") === 0 && (
                <>
                  {hasProfileImage(msg)  && msg.contactPhotoUrl ? (
                    <Image
                      src={`${setBackEndUlr()}/${handeUserProfileImaage(msg)}`}
                      alt="avatar"
                      className="!w-10 !h-10 rounded-full"
                      {...FallbackObj()}
                      preview={false}
                    />
                  ) : (
                    <Avatar
                      size={40}
                      
                      className="bg-gray-400"
                    >
                      {getUserInitial(msg)}
                    </Avatar>
                  )}
                </>
              )}

              <div
                className={`md:!p-3 !p-2 rounded-lg max-w-xs !flex !flex-col gap-1 ${
                  handePostiionMessage(msg, "background")
                    ? "bg-white text-gray-900"
                    : "bg-yellow-100 text-gray-900"
                }`}
              >
                <p className="!flex justify-end"></p>
                <p className="!text-xs md:!text-sm">{msg.message}</p>
                <p>
                  {msg?.media?.length > 0 ? (
                    <>
                      {msg?.media?.map((item: any, mediaIndex: number) => {
                        return (
                          <Image
                            key={mediaIndex}
                            src={`${setBackEndUlr()}/${item.fullPath}`}
                            width={"100%"}
                            height={"300px"}
                            style={{ objectFit: "contain" }}
                            alt={""}
                            {...FallbackObj()}
                          />
                        );
                      })}
                    </>
                  ) : (
                    <>
                      {msg?.messageFiles?.map((src: string, fileIndex: number) => {
                        return (
                          <Image
                            key={fileIndex}
                            style={{ objectFit: "contain" }}
                            src={src}
                            width={"100%"}
                            height={"300px"}
                            {...FallbackObj()}
                          />
                        );
                      })}
                    </>
                  )}
                </p>
                <p className="!flex items-center justify-between gap-2">
                  <span className="text-xs text-gray-500 mt-1 !flex items-center gap-2">
                    <span className="!text-xs">
                      {dayjs(msg.insertDate).format("DD.MM.YYYY")}
                    </span>
                    <span className="!text-xs">
                      {dayjs(msg.insertDate).format("HH:mm")}
                    </span>
                  </span>
                  {msg?.isSaved ? (
                    <CheckOutlined className="text-xs text-green-500" />
                  ) : (
                    <ClockCircleOutlined className="text-xs text-[#87947c]" />
                  )}
                </p>
              </div>

              {handePostiionMessage(msg, "background") === 1 && (
                <>
                  {hasProfileImage(msg)  && msg.contactPhotoUrl ? (
                    

                    
                    <Image
                      preview={false}
                      src={`${setBackEndUlr()}/${handeUserProfileImaage(msg)}`}
                      alt="avatar"
                      className="!w-10 !h-10 rounded-full"
                      {...FallbackObj()}
                    />
                  ) : (
                    <Avatar
                      size={40}
                      icon={<UserOutlined />}
                      className="bg-gray-400"
                    >
                      {getUserInitial(msg)}
                    </Avatar>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
    </ChatMessageListSkeleton>
  );
};

export default MessageList;